import Sidebar from "components/features/sidebar";
import React from "react";

interface HomeLayoutProps {
  children: React.ReactNode;
}

const HomeLayout: React.FC<HomeLayoutProps> = ({ children }) => {
  return (
    <>
      <div className="flex">
        <Sidebar />
        <div className="flex-grow">{children}</div>
      </div>
    </>
  );
};

export default HomeLayout;
